import { type FC, type ReactNode } from "react";

import { faArrowRight } from "@fortawesome/pro-duotone-svg-icons/faArrowRight";
import { faSparkles } from "@fortawesome/pro-duotone-svg-icons/faSparkles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// A suggested question: one click sends it. Violet, because it's the
// assistant's offer, with its sparkle (`sparkle` off where the row is his
// rather than the assistant's). `arrow` off where controls follow it.
export const QuestionRow: FC<{
  onClick(): void;
  disabled?: boolean;
  arrow?: boolean;
  sparkle?: boolean;
  children: ReactNode;
}> = ({ onClick, disabled, arrow = true, sparkle = true, children }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className="group flex w-full cursor-pointer items-start gap-[9px] px-3 py-2 text-left enabled:hover:bg-violet-50 disabled:cursor-default disabled:opacity-45"
  >
    {sparkle && (
      <FontAwesomeIcon
        icon={faSparkles}
        className="mt-[3px] shrink-0 text-[11px] text-violet-600"
      />
    )}
    <span className="min-w-0 flex-1 text-[12.5px] leading-[1.45] text-slate-700 group-enabled:group-hover:text-violet-800">
      {children}
    </span>
    {arrow && (
      <FontAwesomeIcon
        icon={faArrowRight}
        className="mt-[3px] shrink-0 text-xs text-slate-300 group-enabled:group-hover:text-violet-600"
      />
    )}
  </button>
);

// The empty chat's bordered list of questions.
export const QuestionList: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="divide-y divide-slate-100 overflow-hidden rounded-lg border border-slate-200 bg-white">
    {children}
  </div>
);
